<div class="profile-page-section">
    <div class="profile-tabs-section">
        <p class="each-profile-tab" [ngClass]="{'each-profile-tab-selected': selected_tab == 'Manage Profile' }" (click)="changeTab('Manage Profile')">Manage Profile</p>
        <p class="each-profile-tab" [ngClass]="{'each-profile-tab-selected': selected_tab == 'Change Password' }" (click)="changeTab('Change Password')">Change Password</p>
        <p class="each-profile-tab" [ngClass]="{'each-profile-tab-selected': selected_tab == 'Mail Configuration' }" (click)="changeTab('Mail Configuration')">Mail Configuration</p>
        <p class="each-profile-tab" [ngClass]="{'each-profile-tab-selected': selected_tab == 'Notifications' }" (click)="changeTab('Notifications')">Notifications</p>
        <p class="each-profile-tab" [ngClass]="{'each-profile-tab-selected': selected_tab == 'Integrations' }" (click)="changeTab('Integrations')">Integrations</p>
    </div>
    <ng-container *ngIf="profile_data_loaded">
        <div class="each-tab-content-section">
            <div *ngIf="selected_tab == 'Manage Profile'">
                <ng-container *ngIf="(user_details.role.role != 5 && user_details.role.role != 6)">
                    <ng-container *ngTemplateOutlet="profileForm;"></ng-container>
                    <div class="profile-action-section">
                        <button class="profile-action" (click)="updateProfile()">Update Profile</button>
                    </div>
                </ng-container>
                <ng-container *ngIf="(user_details.role.role == 5 || user_details.role.role == 6)">
                    <ng-container *ngIf="advisor_data_loaded">
                        <div class="profile-accordion-section">
                            <div class="profile-accordion-header-section" [ngClass]="{'profile-accordion-error': invalid_personal_info}" (click)="toggle_personal_info = !toggle_personal_info">
                                <span>Personal Information</span>
                                <img src="assets/up_arrow_chat.png" class="profile-accordion-icon" *ngIf="toggle_personal_info" />
                                <img src="assets/down_arrow_chat.png" class="profile-accordion-icon" *ngIf="!toggle_personal_info" />
                            </div>
                            <div class="profile-accordion-content-section" *ngIf="toggle_personal_info">
                                <ng-container *ngTemplateOutlet="profilePersonalForm;"></ng-container>
                            </div>
                        </div>

                        <div class="profile-accordion-section">
                            <div class="profile-accordion-header-section" [ngClass]="{'profile-accordion-error': invalid_contact_info}" (click)="toggle_contact_info = !toggle_contact_info">
                                <span>Primary Contact Information</span>
                                <img src="assets/up_arrow_chat.png" class="profile-accordion-icon" *ngIf="toggle_contact_info" />
                                <img src="assets/down_arrow_chat.png" class="profile-accordion-icon" *ngIf="!toggle_contact_info" />
                            </div>
                            <div class="profile-accordion-content-section" *ngIf="toggle_contact_info">
                                <ng-container *ngTemplateOutlet="profileContactForm;"></ng-container>
                            </div>
                        </div>

                        <div class="profile-accordion-section">
                            <div class="profile-accordion-header-section" [ngClass]="{'profile-accordion-error': invalid_secondary_address_info}" (click)="toggle_secondary_address = !toggle_secondary_address">
                                <span>Address 2 Information (Optional)</span>
                                <img src="assets/up_arrow_chat.png" class="profile-accordion-icon" *ngIf="toggle_secondary_address" />
                                <img src="assets/down_arrow_chat.png" class="profile-accordion-icon" *ngIf="!toggle_secondary_address" />
                            </div>
                            <div class="profile-accordion-content-section" *ngIf="toggle_secondary_address">
                                <ng-container *ngTemplateOutlet="profileSecondaryAddressForm;"></ng-container>
                            </div>
                        </div>

                        <div class="profile-accordion-section">
                            <div class="profile-accordion-header-section" [ngClass]="{'profile-accordion-error': invalid_third_address_info}" (click)="toggle_third_address = !toggle_third_address">
                                <span>Address 3 Information (Optional)</span>
                                <img src="assets/up_arrow_chat.png" class="profile-accordion-icon" *ngIf="toggle_third_address" />
                                <img src="assets/down_arrow_chat.png" class="profile-accordion-icon" *ngIf="!toggle_third_address" />
                            </div>
                            <div class="profile-accordion-content-section" *ngIf="toggle_third_address">
                                <ng-container *ngTemplateOutlet="profileThirdAddressForm;"></ng-container>
                            </div>
                        </div>

                        <div class="profile-accordion-section">
                            <div class="profile-accordion-header-section" [ngClass]="{'profile-accordion-error': invalid_social_network_info}" (click)="toggle_social_network = !toggle_social_network">
                                <span>Social Networking Information</span>
                                <img src="assets/up_arrow_chat.png" class="profile-accordion-icon" *ngIf="toggle_social_network" />
                                <img src="assets/down_arrow_chat.png" class="profile-accordion-icon" *ngIf="!toggle_social_network" />
                            </div>
                            <div class="profile-accordion-content-section" *ngIf="toggle_social_network">
                                <ng-container *ngTemplateOutlet="profileSocialNetworkForm;"></ng-container>
                            </div>
                        </div>

                        <div class="profile-accordion-section">
                            <div class="profile-accordion-header-section" [ngClass]="{'profile-accordion-error': invalid_experience_info}" (click)="toggle_experience_info = !toggle_experience_info">
                                <span>Experience/Qualification Information</span>
                                <img src="assets/up_arrow_chat.png" class="profile-accordion-icon" *ngIf="toggle_experience_info" />
                                <img src="assets/down_arrow_chat.png" class="profile-accordion-icon" *ngIf="!toggle_experience_info" />
                            </div>
                            <div class="profile-accordion-content-section" *ngIf="toggle_experience_info">
                                <ng-container *ngTemplateOutlet="profileExperienceForm;"></ng-container>
                            </div>
                        </div>

                        <div class="profile-accordion-section">
                            <div class="profile-accordion-header-section" [ngClass]="{'profile-accordion-error': invalid_employment_info}" (click)="toggle_employment_info = !toggle_employment_info">
                                <span>Current Employment Information</span>
                                <img src="assets/up_arrow_chat.png" class="profile-accordion-icon" *ngIf="toggle_employment_info" />
                                <img src="assets/down_arrow_chat.png" class="profile-accordion-icon" *ngIf="!toggle_employment_info" />
                            </div>
                            <div class="profile-accordion-content-section" *ngIf="toggle_employment_info">
                                <ng-container *ngTemplateOutlet="profileEmploymentForm;"></ng-container>
                            </div>
                        </div>

                        <div class="profile-accordion-section">
                            <div class="profile-accordion-header-section" [ngClass]="{'profile-accordion-error': invalid_past_experience_info}" (click)="toggle_past_experience_info = !toggle_past_experience_info">
                                <span>Past Experience Information</span>
                                <img src="assets/up_arrow_chat.png" class="profile-accordion-icon" *ngIf="toggle_past_experience_info" />
                                <img src="assets/down_arrow_chat.png" class="profile-accordion-icon" *ngIf="!toggle_past_experience_info" />
                            </div>
                            <div class="profile-accordion-content-section" *ngIf="toggle_past_experience_info">
                                <ng-container *ngTemplateOutlet="profilePastExperienceForm;"></ng-container>
                            </div>
                        </div>

                        <div class="profile-accordion-section">
                            <div class="profile-accordion-header-section" [ngClass]="{'profile-accordion-error': invalid_services_info}" (click)="toggle_services_info = !toggle_services_info">
                                <span>Services Information</span>
                                <img src="assets/up_arrow_chat.png" class="profile-accordion-icon" *ngIf="toggle_services_info" />
                                <img src="assets/down_arrow_chat.png" class="profile-accordion-icon" *ngIf="!toggle_services_info" />
                            </div>
                            <div class="profile-accordion-content-section" *ngIf="toggle_services_info">
                                <ng-container *ngTemplateOutlet="profileServicesForm;"></ng-container>
                            </div>
                        </div>

                        <div class="profile-action-section">
                            <button class="profile-action" (click)="updateAdvisorProfile()">Update Profile</button>
                        </div>
                    </ng-container>
                </ng-container>
            </div>
            <div *ngIf="selected_tab == 'Change Password'">
                <div class="row">
                    <div class="col-md-4">
                        <div class="each-profile-input-section password-input-section">
                            <p class="each-profile-input-label">Old Password</p>
                            <input type="{{ is_old_password_active ? 'password' : 'text' }}" class="each-profile-input password-input" [(ngModel)]="password_details.old" />
                            <img src="assets/show-password.png" class="password-icons" *ngIf="is_old_password_active == true" (click)="is_old_password_active = false" />
                            <img src="assets/hide-password.png" class="password-icons" *ngIf="is_old_password_active == false" (click)="is_old_password_active = true" />
                            <p class="each-profile-input-error" *ngIf="password_details_errors.old">Old Password cannot be empty.</p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="each-profile-input-section password-input-section">
                            <p class="each-profile-input-label">New Password</p>
                            <input type="{{ is_new_password_active ? 'password' : 'text' }}" class="each-profile-input password-input" [(ngModel)]="password_details.new" (input)="passdwordValidation(password_details.new)" />
                            <img src="assets/show-password.png" class="password-icons" *ngIf="is_new_password_active == true" (click)="is_new_password_active = false" />
                            <img src="assets/hide-password.png" class="password-icons" *ngIf="is_new_password_active == false" (click)="is_new_password_active = true" />
                            <p class="each-profile-input-error" *ngIf="password_details_errors.new">New Password must not be the same as the Old Password and cannot be empty.</p>
                            <div class="password-strength-section">
                                <div class="each-password-strength-section">
                                    <img src="assets/ic-circle-tick.png" class="password-strentg-icon" *ngIf="checkPasswordLength(password_details.new)" />
                                    <img src="assets/ic-circle-cross.png" class="password-strentg-icon" *ngIf="!checkPasswordLength(password_details.new)" />
                                    <span>Minimum 8 Characters</span>
                                </div>
                                <div class="each-password-strength-section">
                                    <img src="assets/ic-circle-tick.png" class="password-strentg-icon" *ngIf="checkPasswordUppercase(password_details.new)" />
                                    <img src="assets/ic-circle-cross.png" class="password-strentg-icon" *ngIf="!checkPasswordUppercase(password_details.new)" />
                                    <span>Minimum 1 Uppercase Character</span>
                                </div>
                                <div class="each-password-strength-section">
                                    <img src="assets/ic-circle-tick.png" class="password-strentg-icon" *ngIf="checkPasswordLowercase(password_details.new)" />
                                    <img src="assets/ic-circle-cross.png" class="password-strentg-icon" *ngIf="!checkPasswordLowercase(password_details.new)" />
                                    <span>Minimum 1 Lowercase Character</span>
                                </div>
                                <div class="each-password-strength-section">
                                    <img src="assets/ic-circle-tick.png" class="password-strentg-icon" *ngIf="checkPasswordSpecial(password_details.new)" />
                                    <img src="assets/ic-circle-cross.png" class="password-strentg-icon" *ngIf="!checkPasswordSpecial(password_details.new)" />
                                    <span>Minimum 1 Special Character</span>
                                </div>
                                <div class="each-password-strength-section">
                                    <img src="assets/ic-circle-tick.png" class="password-strentg-icon" *ngIf="checkPasswordNumber(password_details.new)" />
                                    <img src="assets/ic-circle-cross.png" class="password-strentg-icon" *ngIf="!checkPasswordNumber(password_details.new)" />
                                    <span>Minimum 1 Numerical Character</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="each-profile-input-section password-input-section">
                            <p class="each-profile-input-label">Confirm Password</p>
                            <input
                            type="{{ is_confirm_password_active ? 'password' : 'text' }}"
                            class="each-profile-input password-input"
                            [(ngModel)]="password_details.confirm"
                            />
                            <img src="assets/show-password.png" class="password-icons" *ngIf="is_confirm_password_active == true" (click)="is_confirm_password_active = false" />
                            <img src="assets/hide-password.png" class="password-icons" *ngIf="is_confirm_password_active == false" (click)="is_confirm_password_active = true" />
                            <p class="each-profile-input-error" *ngIf="password_details_errors.confirm">New Password & Confirm Password should be same</p>
                        </div>
                    </div>
                </div>
                <div class="profile-action-section">
                    <button class="profile-action" (click)="changePassword()">Change Password</button>
                </div>
            </div>
            <div *ngIf="selected_tab == 'Mail Configuration'">
                <div class="row">
                    <div class="col-md-4">
                        <div class="each-profile-input-section">
                            <p class="each-profile-input-label">Server Type *</p>
                            <mat-select class="each-profile-input" [(ngModel)]="user_details.server_type">
                                <mat-option [value]="''">Select Server Type</mat-option>
                                <mat-option [value]="'outlook'">Outlook</mat-option>
                                <mat-option [value]="'gmail'">Gmail</mat-option>
                            </mat-select>
                            <p class="each-profile-input-error" *ngIf="mail_info_data_errors.server_type">Server Type is Required</p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="each-profile-input-section">
                            <p class="each-profile-input-label">Server Username *</p>
                            <input type="text" class="each-profile-input" [(ngModel)]="user_details.server_username" />
                            <p class="each-profile-input-error" *ngIf="mail_info_data_errors.server_username">Enter valid Server Username</p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="each-profile-input-section password-input-section">
                            <p class="each-profile-input-label">Server Password *</p>
                            <input type="{{ is_server_password_active ? 'password' : 'text' }}" class="each-profile-input password-input" [(ngModel)]="server_password" />
                            <img src="assets/show-password.png" class="password-icons" *ngIf="is_server_password_active == true" (click)="is_server_password_active = false" />
                            <img src="assets/hide-password.png" class="password-icons" *ngIf="is_server_password_active == false" (click)="is_server_password_active = true" />
                            <p class="each-profile-input-error" *ngIf="mail_info_data_errors.server_password">Server Password is Required</p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="each-profile-input-section">
                            <p class="each-profile-input-label">Server Hostname *</p>
                            <input type="text" class="each-profile-input" [(ngModel)]="user_details.server_hostname" />
                            <p class="each-profile-input-error" *ngIf="mail_info_data_errors.server_hostname">Server Hostname is Required</p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="each-profile-input-section">
                            <p class="each-profile-input-label">Server Incoming Mail Port *</p>
                            <input type="text" class="each-profile-input" [(ngModel)]="user_details.server_incoming_port" (keypress)="numberOnly($event)" />
                            <p class="each-profile-input-error" *ngIf="mail_info_data_errors.server_incoming_port">Server Incoming Mail Port is Required</p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="each-profile-input-section">
                            <p class="each-profile-input-label">Server Outgoing Mail Port *</p>
                            <input type="text" class="each-profile-input" [(ngModel)]="user_details.server_outgoing_port" (keypress)="numberOnly($event)" />
                            <p class="each-profile-input-error" *ngIf="mail_info_data_errors.server_outgoing_port">Server Outgoing Mail Port is Required</p>
                        </div>
                    </div>
                </div>
                <div class="profile-action-section">
                    <button class="profile-action" (click)="changeMailInformation()">Update Mail Configuration</button>
                </div>
            </div>
            <div *ngIf="selected_tab == 'Notifications'">
                <!-- <div class="row">
                    <div class="col-md-4">
                        <div class="each-profile-input-section">
                            <p class="each-profile-input-label">Notification Alerts *</p>
                            <mat-select class="each-profile-input" [(ngModel)]="user_details.notification_alerts">
                                <mat-option [value]="''">Select Notification Alerts</mat-option>
                                <mat-option [value]="true">Turn on Notifications</mat-option>
                                <mat-option [value]="false">Turn off Notifications</mat-option>
                            </mat-select>
                            <p class="each-profile-input-error" *ngIf="notification_info_data_errors.notification_alerts">Notification Alerts is Required</p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="each-profile-input-section">
                            <p class="each-profile-input-label">Notification Frequency *</p>
                            <mat-select class="each-profile-input" [(ngModel)]="user_details.notification_frequency">
                                <mat-option [value]="''">Select Notification Frequency</mat-option>
                                <mat-option [value]="'Daily'">Daily</mat-option>
                                <mat-option [value]="'Weekly'">Weekly</mat-option>
                                <mat-option [value]="'Monthly'">Monthly</mat-option>
                                <mat-option [value]="'Quarterly'">Quarterly</mat-option>
                                <mat-option [value]="'Semi Annually'">Semi Annually</mat-option>
                                <mat-option [value]="'Yearly'">Yearly</mat-option>
                            </mat-select>
                            <p class="each-profile-input-error" *ngIf="notification_info_data_errors.notification_frequency">Notification Frequency is Required</p>
                        </div>
                    </div>
                </div> -->

                <div class="section-card">
                    <div class="section-header">
                        <div class="section-icon">
                            <svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line></svg>
                        </div>
                        <div class="section-title">
                            <h3>App notifications</h3>
                            <p>In-product alerts on web and mobile devices.</p>
                        </div>
                    </div>
                    
                    <div class="notification-row">
                        <div class="row-info">
                            <h4>Web notifications</h4>
                            <p>Browser and in-app alerts while you're working in the console.</p>
                        </div>
                        <label class="switch">
                            <input type="checkbox" [(ngModel)]="user_details.enable_web_notifications">
                            <span class="slider"></span>
                        </label>
                    </div>

                    <div class="notification-row">
                        <div class="row-info">
                            <h4>Mobile push notifications</h4>
                            <p>Push alerts on the iOS and Android app for your signed-in devices.</p>
                        </div>
                        <label class="switch">
                            <input type="checkbox"  [(ngModel)]="user_details.enable_mobile_push_notifications">
                            <span class="slider"></span>
                        </label>
                    </div>
                </div>

                <div class="section-card">
                    <div class="section-header">
                        <div class="section-icon">
                            <svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
                        </div>
                        <div class="section-title">
                            <h3>Email notifications</h3>
                            <p>Instant emails per action item, or a scheduled summary.</p>
                        </div>
                    </div>
                    
                    <div class="notification-row">
                        <div class="row-info">
                            <h4>Instant emails for each action item</h4>
                            <p>Send an email as soon as something is assigned to you.</p>
                        </div>
                        <label class="switch">
                            <input type="checkbox"  [(ngModel)]="user_details.enable_instant_email_action_item">
                            <span class="slider"></span>
                        </label>
                    </div>

                    <div class="notification-row" style="flex-direction: column; align-items: stretch; border-bottom: none;">
                        <div style="display: flex; justify-content: space-between; align-items: center;">
                            <div class="row-info">
                                <h4>Summary email</h4>
                                <p>A digest with all your open action items, on the schedule you choose.</p>
                            </div>
                            <label class="switch">
                                <input type="checkbox"  [(ngModel)]="user_details.enable_summary_email">
                                <span class="slider"></span>
                            </label>
                        </div>

                        <div class="nested-config" *ngIf="user_details.enable_summary_email">
                            <div class="form-group" style="margin-bottom: 14px;">
                                <label>Frequency</label>
                                <div class="pill-group">
                                    <button class="pill-btn" [ngClass]="{'active': user_details.summary_email_frequency == 'Daily'}" (click)="user_details.summary_email_frequency = 'Daily'">Daily</button>
                                    <button class="pill-btn" [ngClass]="{'active': user_details.summary_email_frequency == 'Weekly'}" (click)="user_details.summary_email_frequency = 'Weekly'">Weekly</button>
                                    <button class="pill-btn" [ngClass]="{'active': user_details.summary_email_frequency == 'Monthly'}" (click)="user_details.summary_email_frequency = 'Monthly'">Monthly</button>
                                </div>
                            </div>

                            <div class="config-grid">
                                <div class="form-group">
                                    <label>Send at</label>
                                    <mat-select class="form-control" [(ngModel)]="user_details.summary_email_time">
                                        <mat-option *ngFor="let time_slot of time_slots_list" [value]="time_slot">{{time_slot}}</mat-option>
                                    </mat-select>
                                </div>
                                <div class="form-group">
                                    <label>Time zone</label>
                                    <mat-select class="form-control" [(ngModel)]="user_details.summary_email_time_zone">
                                        <mat-option *ngFor="let timezone of timezone_list" [value]="timezone.value">{{timezone.name}}</mat-option>
                                    </mat-select>
                                </div>
                            </div>

                            <label class="checkbox-label">
                                <input type="checkbox" [(ngModel)]="user_details.enable_summary_email_skip">
                                Skip the email when there are no action items
                            </label>
                        </div>
                    </div>
                </div>

                <div class="section-card">
                    <div class="section-header">
                        <div class="section-icon">
                            <svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
                        </div>
                        <div class="section-title">
                            <h3>Text & WhatsApp</h3>
                            <p>Opt in to messaging alerts. You can turn this off anytime.</p>
                        </div>
                    </div>
                    
                    <div class="notification-row" style="border-bottom: none;">
                        <div class="row-info">
                            <h4>Enable messaging notifications</h4>
                            <p>Receive alerts as SMS or WhatsApp messages on your mobile number.</p>
                        </div>
                        <label class="switch">
                            <input type="checkbox" [(ngModel)]="user_details.enable_messaging_notifications">
                            <span class="slider"></span>
                        </label>
                    </div>

                    <div class="notification-row" style="flex-direction: column; align-items: stretch; border-bottom: none;" *ngIf="user_details.enable_messaging_notifications">
                        
                        <div style="display: flex; justify-content: space-between; align-items: center;">
                            <div class="row-info">
                                <h4>Summary Messaging</h4>
                                <p>A digest with all your open action items, on the schedule you choose.</p>
                            </div>
                            <label class="switch">
                                <input type="checkbox"  [(ngModel)]="user_details.enable_summary_messaging">
                                <span class="slider"></span>
                            </label>
                        </div>

                        <div class="nested-config" *ngIf="user_details.enable_summary_messaging">
                            <div class="form-group" style="margin-bottom: 14px;">
                                <label>Frequency</label>
                                <div class="pill-group">
                                    <button class="pill-btn" [ngClass]="{'active': user_details.summary_messaging_frequency == 'Daily'}" (click)="user_details.summary_messaging_frequency = 'Daily'">Daily</button>
                                    <button class="pill-btn" [ngClass]="{'active': user_details.summary_messaging_frequency == 'Weekly'}" (click)="user_details.summary_messaging_frequency = 'Weekly'">Weekly</button>
                                    <button class="pill-btn" [ngClass]="{'active': user_details.summary_messaging_frequency == 'Monthly'}" (click)="user_details.summary_messaging_frequency = 'Monthly'">Monthly</button>
                                </div>
                            </div>

                            <div class="config-grid">
                                <div class="form-group">
                                    <label>Send at</label>
                                    <mat-select class="form-control" [(ngModel)]="user_details.summary_messaging_time">
                                        <mat-option *ngFor="let time_slot of time_slots_list" [value]="time_slot">{{time_slot}}</mat-option>
                                    </mat-select>
                                </div>
                                <div class="form-group">
                                    <label>Time zone</label>
                                    <mat-select class="form-control" [(ngModel)]="user_details.summary_messaging_time_zone">
                                        <mat-option *ngFor="let timezone of timezone_list" [value]="timezone.value">{{timezone.name}}</mat-option>
                                    </mat-select>
                                </div>
                            </div>

                            <label class="checkbox-label">
                                <input type="checkbox" [(ngModel)]="user_details.enable_summary_messaging_skip">
                                Skip the SMS or WhatsApp when there are no action items
                            </label>
                        </div>
                    </div>
                </div>

                <div class="section-card">
                    <div class="section-header">
                        <div class="section-icon">
                            <svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><circle cx="12" cy="13" r="8"></circle><path d="M12 9v4l2 2"></path><path d="M5 3L2 6"></path><path d="M19 3l3 3"></path></svg>
                        </div>
                        <div class="section-title">
                            <h3>Pending task reminders</h3>
                            <p>Nudge yourself on open tasks that are still pending.</p>
                        </div>
                    </div>
                    
                    <div class="notification-row" style="flex-direction: column; align-items: stretch; border-bottom: none;">
                        <div style="display: flex; justify-content: space-between; align-items: center;">
                            <div class="row-info">
                                <h4>Remind me about pending tasks</h4>
                            </div>
                            <label class="switch">
                                <input type="checkbox" [(ngModel)]="user_details.enable_remind_pending_tasks">
                                <span class="slider"></span>
                            </label>
                        </div>

                        <div class="notification-row" style="flex-direction: column; align-items: stretch; border-bottom: none;" *ngIf="user_details.enable_remind_pending_tasks">
                            <div class="nested-config">
                                <div class="form-group" style="margin-bottom: 14px;">
                                    <label>Frequency</label>
                                    <div class="pill-group">
                                        <button class="pill-btn" [ngClass]="{'active': user_details.remind_pending_tasks_frequency == 'Daily'}" (click)="user_details.remind_pending_tasks_frequency = 'Daily'">Daily</button>
                                        <button class="pill-btn" [ngClass]="{'active': user_details.remind_pending_tasks_frequency == 'Weekly'}" (click)="user_details.remind_pending_tasks_frequency = 'Weekly'">Weekly</button>
                                        <button class="pill-btn" [ngClass]="{'active': user_details.remind_pending_tasks_frequency == 'Monthly'}" (click)="user_details.remind_pending_tasks_frequency = 'Monthly'">Monthly</button>
                                    </div>
                                </div>

                                <div class="config-grid">
                                    <div class="form-group">
                                        <label>Send at</label>
                                        <mat-select class="form-control" [(ngModel)]="user_details.remind_pending_tasks_time">
                                            <mat-option *ngFor="let time_slot of time_slots_list" [value]="time_slot">{{time_slot}}</mat-option>
                                        </mat-select>
                                    </div>
                                    <div class="form-group">
                                        <label>Time zone</label>
                                        <mat-select class="form-control" [(ngModel)]="user_details.remind_pending_tasks_time_zone">
                                            <mat-option *ngFor="let timezone of timezone_list" [value]="timezone.value">{{timezone.name}}</mat-option>
                                        </mat-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <ng-container *ngIf="user_details.role.role == 3">
                    <div class="section-card">
                        <div class="section-header">
                            <div class="section-icon">
                                <svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M12 2v6" />
                                    <path d="M4.93 10.93l4.24 4.24" />
                                    <path d="M2 18h6" />
                                    <path d="M18 12l4-4-4-4" />
                                    <path d="M6 12h12v8a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-8z" />
                                </svg>
                            </div>
                            <div class="section-title">
                                <h3>Escalations</h3>
                                <p>Be alerted when an advisor's pending-task reminders go unanswered.</p>
                            </div>
                        </div>
                        
                        <div class="notification-row" style="flex-direction: column; align-items: stretch; border-bottom: none;">
                            <div style="display: flex; justify-content: space-between; align-items: center;">
                                <div style="display: flex; gap: 12px; align-items: center;">
                                    <div class="item-icon">
                                        <svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><line x1="7" y1="17" x2="17" y2="7"></line><polyline points="7 7 17 7 17 17"></polyline></svg>
                                    </div>
                                    <div class="row-info">
                                        <h4>Escalate unanswered reminders</h4>
                                        <p>Get looped in when an advisor's reminders go unaddressed.</p>
                                    </div>
                                </div>
                                <label class="switch">
                                    <input type="checkbox" [(ngModel)]="user_details.enable_escalate_reminders">
                                    <span class="slider"></span>
                                </label>
                            </div>

                            <div class="nested-config" *ngIf="user_details.enable_escalate_reminders">
                                <div class="form-group">
                                    <label>Escalation rule</label>
                                    <div class="inline-controls">
                                        <span>Escalate after</span>
                                        <input type="number" [ngClass]="{'error-input': user_details.escalate_reminder_count == 0}" [(ngModel)]="user_details.escalate_reminder_count" min="1" step="1">
                                        <span>reminders, or when a task is</span>
                                        <input type="number" [ngClass]="{'error-input': user_details.escalate_overdue_days == 0}" [(ngModel)]="user_details.escalate_overdue_days" min="1" step="1">
                                        <span>days overdue.</span>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label>Escalate to</label>
                                    <!-- <div class="inline-controls">
                                        <span class="badge">Sales Leader</span>
                                        <span style="color: #64748b;">Escalations always route to the Sales Leader.</span>
                                    </div> -->
                                    <mat-select class="form-control" [(ngModel)]="user_details.escalate_to">
                                        <mat-option [value]="'Sales Leader'">Sales Leader</mat-option>
                                    </mat-select>
                                </div>

                                <div class="form-group">
                                    <label>Notify me via</label>
                                    <mat-select class="form-control" [(ngModel)]="user_details.escalate_notify_via">
                                        <mat-option [value]="'Email + App notification'">Email + App notification</mat-option>
                                        <mat-option [value]="'Email only'">Email only</mat-option>
                                        <mat-option [value]="'App notification only'">App notification only</mat-option>
                                    </mat-select>
                                </div>

                                <div class="summary-banner">
                                    Summary: after {{user_details.escalate_reminder_count}} unanswered reminders (or {{user_details.escalate_overdue_days}} days overdue), notify the {{user_details.escalate_to}}.
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>


                <div class="profile-action-section">
                    <!-- <button class="profile-action" (click)="changeNotificationInformation()">Update Notifications</button> -->
                    <button class="profile-action" (click)="changeNotificationConfigurationInformation()">Update Notifications</button>
                </div>
            </div>
            <div *ngIf="selected_tab == 'Integrations'">

                <div class="integrations-section">
                    <div class="zoom-setup-section">
                        <div class="zoom-setup-heading-section">
                            <p class="zoom-setup-heading">Set up Zoom for yourself</p>
                            <!-- <img src="assets/zoom-meeting.png" class="integration-icon" /> -->
                            <img src="assets/zoom-integration.png" />
                        </div>
                        <div class="zoom-setup-content-section">
                            <ul class="integration-setup-list">
                                <li>Automatically create Zoom meetings at the same time an event is scheduled.</li>
                                <li>Instantly share event details.</li>
                            </ul>
                            <div>
                                <p class="integration-setup-heading">Requirements</p>
                                <ul class="integration-setup-list">
                                    <li>A Zoom account.</li>
                                </ul>
                            </div>
                        </div>
                        <div class="zoom-setup-footer-section">
                            <button class="profile-action" *ngIf="!user_details.Zoom_connected && !connect_zoom_loader" (click)="connectZoom()">Connect to Zoom</button>
                            <button class="profile-action" *ngIf="!user_details.Zoom_connected && connect_zoom_loader">Connecting to Zoom ...</button>
                            <button class="profile-action" *ngIf="user_details.Zoom_connected" (click)="disconnectZoom()">Disconnect</button>
                        </div>
                    </div>

                    <div class="zoom-setup-section">
                        <div class="zoom-setup-heading-section">
                            <p class="zoom-setup-heading">Set up Salesforce for yourself</p>
                            <!-- <img src="assets/zoom-meeting.png" class="integration-icon" /> -->
                            <img src="assets/salesforce-integration.png" />
                        </div>
                        <div class="zoom-setup-content-section">
                            <ul class="integration-setup-list">
                                <li>Access data</li>
                                <li>Data Flow</li>
                            </ul>
                            <div>
                                <p class="integration-setup-heading">Requirements</p>
                                <ul class="integration-setup-list">
                                    <li>A Salesforce account.</li>
                                </ul>
                            </div>
                        </div>
                        <div class="zoom-setup-footer-section">
                            <button class="profile-action" *ngIf="!user_details.Salesforce_connected && !connect_salesforce_loader" (click)="connectSalesforce()">Connect to Salesforce</button>
                            <button class="profile-action" *ngIf="!user_details.Salesforce_connected && connect_salesforce_loader">Connecting to Salesforce...</button>
                            <button class="profile-action" *ngIf="user_details.Salesforce_connected" (click)="disconnectSalesforce()">Disconnect</button>
                        </div>
                    </div>

                    <div class="zoom-setup-section">
                        <div class="zoom-setup-heading-section">
                            <p class="zoom-setup-heading">Set up Linkedin for yourself</p>
                            <!-- <img src="assets/zoom-meeting.png" class="integration-icon" /> -->
                            <img src="assets/linkedin-integration.png" />
                        </div>
                        <div class="zoom-setup-content-section">
                            <ul class="integration-setup-list">
                                <li>Create Campaigns</li>
                                <li>Manage Campaigns</li>
                            </ul>
                            <div>
                                <p class="integration-setup-heading">Requirements</p>
                                <ul class="integration-setup-list">
                                    <li>A Linkedin account.</li>
                                </ul>
                            </div>
                        </div>
                        <div class="zoom-setup-footer-section">
                            <button class="profile-action" *ngIf="!user_details.Linkedin_connected && !connect_linkedin_loader" (click)="connectLinkedin()">Connect to Linkedin</button>
                            <button class="profile-action" *ngIf="!user_details.Linkedin_connected && connect_linkedin_loader">Connecting to Linkedin...</button>
                            <button class="profile-action" *ngIf="user_details.Linkedin_connected" (click)="disconnectLinkedin()">Disconnect</button>
                        </div>
                    </div>

                    <div class="zoom-setup-section">
                        <div class="zoom-setup-heading-section">
                            <p class="zoom-setup-heading">Set up Google Meet for yourself</p>
                            <!-- <img src="assets/zoom-meeting.png" class="integration-icon" /> -->
                            <img src="assets/google-meet.png" />
                        </div>
                        <div class="zoom-setup-content-section">
                            <ul class="integration-setup-list">
                                <li>Automatically create Google meetings at the same time an event is scheduled.</li>
                                <li>Instantly share event details.</li>
                            </ul>
                            <div>
                                <p class="integration-setup-heading">Requirements</p>
                                <ul class="integration-setup-list">
                                    <li>A Google account.</li>
                                </ul>
                            </div>
                        </div>
                        <div class="zoom-setup-footer-section">
                            <button class="profile-action" *ngIf="!user_details.Google_Meet_connected && !connect_google_loader" (click)="connectGoogle()">Connect to Google</button>
                            <button class="profile-action" *ngIf="!user_details.Google_Meet_connected && connect_google_loader">Connecting to Google ...</button>
                            <button class="profile-action" *ngIf="user_details.Google_Meet_connected" (click)="disconnectGoogle()">Disconnect</button>
                        </div>
                    </div>

                    <!-- <div class="zoom-setup-section">
                        <div class="zoom-setup-heading-section">
                            <p class="zoom-setup-heading">Set up Zoho CRM for yourself</p>
                            <img src="assets/zoho.png" />
                        </div>
                        <div class="zoom-setup-content-section">
                            <ul class="integration-setup-list">
                                <li>Access data</li>
                                <li>Data Flow</li>
                            </ul>
                            <div>
                                <p class="integration-setup-heading">Requirements</p>
                                <ul class="integration-setup-list">
                                    <li>A Zoho account.</li>
                                </ul>
                            </div>
                        </div>
                        <div class="zoom-setup-footer-section">
                            <button class="profile-action" *ngIf="!user_details.Zoho_connected && !connect_zoho_loader" (click)="connectZoho()">Connect to Zoho</button>
                            <button class="profile-action" *ngIf="!user_details.Zoho_connected && connect_zoho_loader">Connecting to Zoho ...</button>
                            <button class="profile-action" *ngIf="user_details.Zoho_connected" (click)="disconnectZoho()">Disconnect</button>
                        </div>
                    </div> -->

                    <div class="zoom-setup-section">
                        <div class="zoom-setup-heading-section">
                            <p class="zoom-setup-heading">Set up OnceHub for yourself</p>
                            <!-- <img src="assets/OnceHub.png" class="integration-icon" /> -->
                            <img src="assets/OnceHub.svg" class="calender-integration-icon" />
                        </div>
                        <div class="zoom-setup-content-section">
                            <ul class="integration-setup-list">
                                <li>Convenient Scheduling.</li>
                                <li>Instantly share event details.</li>
                            </ul>
                            <div>
                                <p class="integration-setup-heading">Requirements</p>
                                <ul class="integration-setup-list">
                                    <li>A OnceHub account.</li>
                                </ul>
                            </div>
                        </div>
                        <div class="zoom-setup-footer-section">
                            <button class="profile-action" *ngIf="!user_details.OnceHub_connected" (click)="openconnectCalenderIntegration(5, 'OnceHub', 'OnceHub_connected')">Connect to OnceHub</button>
                            <button class="profile-action" *ngIf="user_details.OnceHub_connected" (click)="disConnectCalenderIntegration('OnceHub_connected', 'OnceHub')">Disconnect</button>
                        </div>
                    </div>

                    <div class="zoom-setup-section">
                        <div class="zoom-setup-heading-section">
                            <p class="zoom-setup-heading">Set up Calendly for yourself</p>
                            <!-- <img src="assets/calendly_logo.png" class="integration-icon" /> -->
                            <img src="assets/calendly_logo.svg" class="calender-integration-icon" />
                        </div>
                        <div class="zoom-setup-content-section">
                            <ul class="integration-setup-list">
                                <li>Convenient Scheduling.</li>
                                <li>Instantly share event details.</li>
                            </ul>
                            <div>
                                <p class="integration-setup-heading">Requirements</p>
                                <ul class="integration-setup-list">
                                    <li>A Calendly account.</li>
                                </ul>
                            </div>
                        </div>
                        <div class="zoom-setup-footer-section">
                            <button class="profile-action" *ngIf="!user_details.Calendly_connected" (click)="openconnectCalenderIntegration(4, 'Calendly', 'Calendly_connected')">Connect to Calendly</button>
                            <button class="profile-action" *ngIf="user_details.Calendly_connected" (click)="disConnectCalenderIntegration('Calendly_connected', 'Calendly')">Disconnect</button>
                        </div>
                    </div>

                    <div class="zoom-setup-section">
                        <div class="zoom-setup-heading-section">
                            <p class="zoom-setup-heading">Set up Coconut for yourself</p>
                            <!-- <img src="assets/coconut_logo.png" class="integration-icon" /> -->
                            <img src="assets/coconut_logo.svg" class="calender-integration-icon" />
                        </div>
                        <div class="zoom-setup-content-section">
                            <ul class="integration-setup-list">
                                <li>Convenient Scheduling.</li>
                                <li>Instantly share event details.</li>
                            </ul>
                            <div>
                                <p class="integration-setup-heading">Requirements</p>
                                <ul class="integration-setup-list">
                                    <li>A Coconut Software account.</li>
                                </ul>
                            </div>
                        </div>
                        <div class="zoom-setup-footer-section">
                            <button class="profile-action" *ngIf="!user_details.Coconut_Software_connected" (click)="openconnectCalenderIntegration(6, 'Coconut Software', 'Coconut_Software_connected')">Connect to Coconut Software</button>
                            <button class="profile-action" *ngIf="user_details.Coconut_Software_connected" (click)="disConnectCalenderIntegration('Coconut_Software_connected', 'Coconut Software')">Disconnect</button>
                        </div>
                    </div>

                </div>

                <!-- <div class="profile-accordion-section">
                    <div class="profile-accordion-header-section" (click)="toggle_zoom_integration = !toggle_zoom_integration">
                        <span>Zoom</span>
                        <img src="assets/up_arrow_chat.png" class="profile-accordion-icon" *ngIf="toggle_zoom_integration" />
                        <img src="assets/down_arrow_chat.png" class="profile-accordion-icon" *ngIf="!toggle_zoom_integration" />
                    </div>
                    <div class="profile-accordion-content-section" *ngIf="toggle_zoom_integration">
                        <div class="zoom-setup-section">
                            <div class="zoom-setup-heading-section">
                                <p class="zoom-setup-heading">Set up Zoom for yourself</p>
                                <img src="assets/zoom-meeting.png" class="integration-icon" />
                            </div>
                            <div class="zoom-setup-content-section">
                                <ul class="integration-setup-list">
                                    <li>Automatically create Zoom meetings at the same time an event is scheduled.</li>
                                    <li>Instantly share event details.</li>
                                </ul>
                                <div>
                                    <p class="integration-setup-heading">Requirements</p>
                                    <ul class="integration-setup-list">
                                        <li>A Zoom account.</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="zoom-setup-footer-section">
                                <button class="profile-action" *ngIf="!user_details.Zoom_connected && !connect_zoom_loader" (click)="connectZoom()">Connect to Zoom</button>
                                <button class="profile-action" *ngIf="!user_details.Zoom_connected && connect_zoom_loader">Connecting to Zoom ...</button>
                                <button class="profile-action" *ngIf="user_details.Zoom_connected" (click)="disconnectZoom()">Disconnect</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="profile-accordion-section">
                    <div class="profile-accordion-header-section" (click)="toggle_salesforce_integration = !toggle_salesforce_integration">
                        <span>Salesforce</span>
                        <img src="assets/up_arrow_chat.png" class="profile-accordion-icon" *ngIf="toggle_salesforce_integration" />
                        <img src="assets/down_arrow_chat.png" class="profile-accordion-icon" *ngIf="!toggle_salesforce_integration" />
                    </div>
                    <div class="profile-accordion-content-section" *ngIf="toggle_salesforce_integration">
                        <div class="zoom-setup-section">
                            <div class="zoom-setup-heading-section">
                                <p class="zoom-setup-heading">Set up Salesforce for yourself</p>
                                <img src="assets/zoom-meeting.png" class="integration-icon" />
                            </div>
                            <div class="zoom-setup-content-section">
                                <ul class="integration-setup-list">
                                    <li>Automatically create Zoom meetings at the same time an event is scheduled.</li>
                                    <li>Instantly share event details.</li>
                                </ul>
                                <div>
                                    <p class="integration-setup-heading">Requirements</p>
                                    <ul class="integration-setup-list">
                                        <li>A Salesforce account.</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="zoom-setup-footer-section">
                                <button class="profile-action" *ngIf="!user_details.Salesforce_connected && !connect_salesforce_loader" (click)="connectSalesforce()">Connect to Salesforce</button>
                                <button class="profile-action" *ngIf="!user_details.Salesforce_connected && connect_salesforce_loader">Connecting to Salesforce...</button>
                                <button class="profile-action" *ngIf="user_details.Salesforce_connected" (click)="disconnectSalesforce()">Disconnect</button>
                            </div>
                        </div>
                    </div>
                </div> -->

            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="!profile_data_loaded">
        <app-loader [loading_text]="'Loading Profile'"></app-loader>
    </ng-container>
</div>

<ng-template #profileForm>
    <div class="row">
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">First Name *</p>
                <input type="text" class="each-profile-input" [(ngModel)]="user_details.first_name" />
                <p class="each-profile-input-error" *ngIf="profile_data_errors.first_name">First Name cannot be empty.</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Middle Name</p>
                <input type="text" class="each-profile-input" [(ngModel)]="user_details.middle_name" />
                <p class="each-profile-input-error" *ngIf="profile_data_errors.middle_name">Middle Name cannot be empty.</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Last Name *</p>
                <input type="text" class="each-profile-input" [(ngModel)]="user_details.last_name" />
                <p class="each-profile-input-error" *ngIf="profile_data_errors.last_name">Last Name cannot be empty.</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Email *</p>
                <input type="text" class="each-profile-input" [(ngModel)]="user_details.email" [readOnly]="true" />
                <p class="each-profile-input-error" *ngIf="profile_data_errors.email">Enter valid Email.</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Phone Number * {{APP_CONSTANTS.PHONE_NUMBER_FORMAT}}</p>
                <input type="text" class="each-profile-input" [(ngModel)]="user_details.phone_number" maxlength="{{APP_CONSTANTS.PHONE_NUMBER_LENGTH}}" appFormatPhoneNumber />
                <!-- (input)="formatPhoneNumber($event)" -->
                <p class="each-profile-input-error" *ngIf="profile_data_errors.phone_number">Phone number must be valid</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Date of Birth *</p>
                <input
                type="text"
                class="each-profile-input"
                bsDatepicker
                [(ngModel)]="user_details.date_of_birth"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                />
                <p class="each-profile-input-error" *ngIf="profile_data_errors.date_of_birth">Date of Birth cannot be empty.</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Address</p>
                <input type="text" class="each-profile-input" [(ngModel)]="user_details.address" />
                <p class="each-profile-input-error" *ngIf="profile_data_errors.address">Address cannot be empty.</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">City</p>
                <input type="text" class="each-profile-input" [(ngModel)]="user_details.city" />
                <p class="each-profile-input-error" *ngIf="profile_data_errors.city">City cannot be empty.</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">State</p>
                <mat-select class="each-profile-input" [(ngModel)]="user_details.state_id">
                    <mat-option [value]="''">Select State</mat-option>
                    <mat-option *ngFor="let state of states_list" [value]="state.id">{{state.name}} ({{state.code}})</mat-option>
                </mat-select>
                <p class="each-profile-input-error" *ngIf="profile_data_errors.state_id">State cannot be empty.</p>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #profilePersonalForm>
    <div class="row">
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Advisor ID *</p>
                <input type="text" class="each-profile-input" [(ngModel)]="advisor_data.advisor_id" />
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.advisor_id">Advisor ID cannot be empty.</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">First Name *</p>
                <input type="text" class="each-profile-input" [(ngModel)]="advisor_data.first_name" />
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.first_name">First Name cannot be empty.</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Middle Name</p>
                <input type="text" class="each-profile-input" [(ngModel)]="advisor_data.middle_name" />
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.middle_name">Middle Name cannot be empty.</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Last Name *</p>
                <input type="text" class="each-profile-input" [(ngModel)]="advisor_data.last_name" />
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.last_name">Last Name cannot be empty.</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Email *</p>
                <input type="text" class="each-profile-input" [(ngModel)]="advisor_data.email" [readOnly]="true" />
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.email">Enter valid Email.</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Gender</p>
                <mat-select class="each-profile-input" [(ngModel)]="advisor_data.gender_id">
                    <mat-option [value]="''">Select Gender</mat-option>
                    <mat-option *ngFor="let gender of genders_list" [value]="gender.id">{{gender.name}}</mat-option>
                </mat-select>
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.gender_id">Gender cannot be empty.</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Phone Number * {{APP_CONSTANTS.PHONE_NUMBER_FORMAT}}</p>
                <input type="text" class="each-profile-input" [(ngModel)]="advisor_data.phone_number" maxlength="{{APP_CONSTANTS.PHONE_NUMBER_LENGTH}}" appFormatPhoneNumber />
                <!-- (input)="formatPhoneNumber($event)" -->
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.phone_number">Phone number must be valid</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Date of Birth *</p>
                <input
                type="text"
                class="each-profile-input"
                bsDatepicker
                [(ngModel)]="advisor_data.date_of_birth"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                />
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.date_of_birth">Date of Birth cannot be empty.</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Status *</p>
                <mat-select class="each-profile-input" [(ngModel)]="advisor_data.advisor_status_id">
                    <mat-option [value]="''">Select Status</mat-option>
                    <mat-option *ngFor="let advisor_status of advisor_status_list" [value]="advisor_status.id">{{advisor_status.name}}</mat-option>
                </mat-select>
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.advisor_status_id">Status cannot be empty.</p>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #profileContactForm>
    <div class="row">
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Address Line 1 *</p>
                <input type="text" class="each-profile-input" [(ngModel)]="advisor_data.address_line_1" />
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.address_line_1">Address Line 1 cannot be empty.</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Address Line 2</p>
                <input type="text" class="each-profile-input" [(ngModel)]="advisor_data.address_line_2" />
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.address_line_2">Address Line 2 cannot be empty.</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">City *</p>
                <input type="text" class="each-profile-input" [(ngModel)]="advisor_data.city" />
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.city">City cannot be empty.</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">State *</p>
                <mat-select class="each-profile-input" [(ngModel)]="advisor_data.state_id">
                    <mat-option [value]="''">Select State</mat-option>
                    <mat-option *ngFor="let state of states_list" [value]="state.id">{{state.name}} ({{state.code}})</mat-option>
                </mat-select>
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.state_id">State cannot be empty.</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Region *</p>
                <mat-select class="each-profile-input" [(ngModel)]="advisor_data.region_id">
                    <mat-option [value]="''">Select Region</mat-option>
                    <mat-option *ngFor="let region of region_list" [value]="region.id">{{region.name}}</mat-option>
                </mat-select>
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.region_id">Region cannot be empty.</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Zip Code *</p>
                <input type="text" class="each-profile-input" [(ngModel)]="advisor_data.zip_code" />
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.zip_code">Zip Code cannot be empty.</p>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #profileSecondaryAddressForm>
    <div class="row">
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Address Line 1</p>
                <input type="text" class="each-profile-input" [(ngModel)]="advisor_data.address_2_line_1" />
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.address_2_line_1">Address Line 1 cannot be empty.</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Address Line 2</p>
                <input type="text" class="each-profile-input" [(ngModel)]="advisor_data.address_2_line_2" />
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.address_2_line_2">Address Line 2 cannot be empty.</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">City</p>
                <input type="text" class="each-profile-input" [(ngModel)]="advisor_data.address_2_city" />
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.address_2_city">City cannot be empty.</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">State</p>
                <mat-select class="each-profile-input" [(ngModel)]="advisor_data.address_2_state_id">
                    <mat-option [value]="''">Select State</mat-option>
                    <mat-option *ngFor="let state of states_list" [value]="state.id">{{state.name}} ({{state.code}})</mat-option>
                </mat-select>
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.address_2_state_id">State cannot be empty.</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Region</p>
                <mat-select class="each-profile-input" [(ngModel)]="advisor_data.address_2_region_id">
                    <mat-option [value]="''">Select Region</mat-option>
                    <mat-option *ngFor="let region of region_list" [value]="region.id">{{region.name}}</mat-option>
                </mat-select>
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.address_2_region_id">Region cannot be empty.</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Zip Code</p>
                <input type="text" class="each-profile-input" [(ngModel)]="advisor_data.address_2_zip_code" />
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.address_2_zip_code">Zip Code cannot be empty.</p>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #profileThirdAddressForm>
    <div class="row">
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Address Line 1</p>
                <input type="text" class="each-profile-input" [(ngModel)]="advisor_data.address_3_line_1" />
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.address_3_line_1">Address Line 1 cannot be empty.</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Address Line 2</p>
                <input type="text" class="each-profile-input" [(ngModel)]="advisor_data.address_3_line_2" />
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.address_3_line_2">Address Line 2 cannot be empty.</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">City</p>
                <input type="text" class="each-profile-input" [(ngModel)]="advisor_data.address_3_city" />
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.address_3_city">City cannot be empty.</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">State</p>
                <mat-select class="each-profile-input" [(ngModel)]="advisor_data.address_3_state_id">
                    <mat-option [value]="''">Select State</mat-option>
                    <mat-option *ngFor="let state of states_list" [value]="state.id">{{state.name}} ({{state.code}})</mat-option>
                </mat-select>
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.address_3_state_id">State cannot be empty.</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Region</p>
                <mat-select class="each-profile-input" [(ngModel)]="advisor_data.address_3_region_id">
                    <mat-option [value]="''">Select Region</mat-option>
                    <mat-option *ngFor="let region of region_list" [value]="region.id">{{region.name}}</mat-option>
                </mat-select>
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.address_3_region_id">Region cannot be empty.</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Zip Code</p>
                <input type="text" class="each-profile-input" [(ngModel)]="advisor_data.address_3_zip_code" />
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.address_3_zip_code">Zip Code cannot be empty.</p>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #profileSocialNetworkForm>
    <div class="row">
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Linkedin</p>
                <input type="text" class="each-profile-input" [(ngModel)]="advisor_data.linkedin_url" />
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.linkedin_url">Linkedin cannot be empty.</p>
            </div>
        </div>

        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Twitter</p>
                <input type="text" class="each-profile-input" [(ngModel)]="advisor_data.twitter_url" />
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.twitter_url">Twitter cannot be empty.</p>
            </div>
        </div>

        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Facebook</p>
                <input type="text" class="each-profile-input" [(ngModel)]="advisor_data.facebook_url" />
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.facebook_url">Facebook cannot be empty.</p>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #profileExperienceForm>
    <div class="row">
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Total Experience *</p>
                <input type="text" class="each-profile-input" [(ngModel)]="advisor_data.total_experience" />
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.total_experience">Total Experience cannot be empty.</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">States Registered in *</p>
                <mat-select multiple class="each-profile-input" [(ngModel)]="advisor_data.states_registered">
                    <mat-option *ngFor="let state of states_list" [value]="state.code">{{state.name}} ({{state.code}})</mat-option>
                </mat-select>
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.states_registered">States Registered should be atleast one</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Number of Licenses</p>
                <mat-select multiple class="each-profile-input" [(ngModel)]="advisor_data.total_licenses">
                    <mat-option *ngFor="let license of licenses_list" [value]="license.id">{{license.name}}</mat-option>
                </mat-select>
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.total_licenses">Number of Licenses should be atleast one</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Number of Certificates *</p>
                <mat-select multiple class="each-profile-input" [(ngModel)]="advisor_data.certificates">
                    <mat-option *ngFor="let certificate of certificates_list" [value]="certificate.id">{{certificate.name}}</mat-option>
                </mat-select>
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.certificates">Number of Certificates should be atleast one</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Professional Associations *</p>
                <mat-select multiple class="each-profile-input" [(ngModel)]="advisor_data.professional_associations">
                    <mat-option *ngFor="let professional_association of professional_associations_list" [value]="professional_association.id">{{professional_association.name}}</mat-option>
                </mat-select>
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.professional_associations">Professional Associations should be atleast one</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Advisor Type</p>
                <mat-select class="each-profile-input" [(ngModel)]="advisor_data.advisor_type_id">
                    <mat-option [value]="''">Select Advisor Type</mat-option>
                    <mat-option *ngFor="let advisor_type of advisor_type_list" [value]="advisor_type.id">{{advisor_type.name}}</mat-option>
                </mat-select>
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.advisor_type_id">Advisor Type cannot be empty.</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Dually Licensed</p>
                <mat-select class="each-profile-input" [(ngModel)]="advisor_data.dually_licensed">
                    <mat-option [value]="''">Select Dually Licensed</mat-option>
                    <mat-option [value]="true">Yes</mat-option>
                    <mat-option [value]="false">No</mat-option>
                </mat-select>
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.dually_licensed">Dually Licensed cannot be empty.</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Dually Registered</p>
                <mat-select class="each-profile-input" [(ngModel)]="advisor_data.dually_registered">
                    <mat-option [value]="''">Select Dually Registered</mat-option>
                    <mat-option [value]="true">Yes</mat-option>
                    <mat-option [value]="false">No</mat-option>
                </mat-select>
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.dually_registered">Dually Registered cannot be empty.</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Regulatory Disclosures</p>
                <mat-select class="each-profile-input" [(ngModel)]="advisor_data.regulatory_disclosures">
                    <mat-option [value]="''">Select Regulatory Disclosures</mat-option>
                    <mat-option [value]="true">Yes</mat-option>
                    <mat-option [value]="false">No</mat-option>
                </mat-select>
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.regulatory_disclosures">Regulatory Disclosures cannot be empty.</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Sells Insurance Products</p>
                <mat-select class="each-profile-input" [(ngModel)]="advisor_data.sells_insurance_products">
                    <mat-option [value]="''">Select Sells Insurance Products</mat-option>
                    <mat-option [value]="true">Yes</mat-option>
                    <mat-option [value]="false">No</mat-option>
                </mat-select>
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.sells_insurance_products">Sells Insurance Products cannot be empty.</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Sells Retirement Products</p>
                <mat-select class="each-profile-input" [(ngModel)]="advisor_data.sells_retirement_products">
                    <mat-option [value]="''">Select Sells Retirement Products</mat-option>
                    <mat-option [value]="true">Yes</mat-option>
                    <mat-option [value]="false">No</mat-option>
                </mat-select>
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.sells_retirement_products">Sells Retirement Products cannot be empty.</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Year became Representative</p>
                <mat-select class="each-profile-input" [(ngModel)]="advisor_data.date_became_representative_year">
                    <mat-option [value]="''">Select Year became Representative</mat-option>
                    <mat-option *ngFor="let year of represent_years" [value]="year">{{ year }}</mat-option>
                </mat-select>
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.date_became_representative_year">Year became Representative cannot be empty.</p>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #profileEmploymentForm>
    <div class="row">
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Employment ID</p>
                <input type="text" class="each-profile-input" [(ngModel)]="advisor_data.employment_id" />
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.employment_id">Employment ID cannot be empty.</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Employment Type</p>
                <mat-select class="each-profile-input" [(ngModel)]="advisor_data.employment_type_id">
                    <mat-option [value]="''">Select Employment Type</mat-option>
                    <mat-option *ngFor="let employment_type of employment_type_list" [value]="employment_type.id">{{employment_type.name}}</mat-option>
                </mat-select>
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.employment_type_id">Employment Type cannot be empty.</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Company Name</p>
                <input type="text" class="each-profile-input" [(ngModel)]="advisor_data.financial_institution.institution_name" [readOnly]="true" />
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.financial_institution.institution_name">Company Name cannot be empty.</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Company Branch *</p>
                <mat-select class="each-profile-input" [(ngModel)]="advisor_data.financial_institution_branch">
                    <mat-option [value]="''">Select Company Branch</mat-option>
                    <mat-option *ngFor="let branch of advisor_data.financial_institution.branches" [value]="branch.id">{{branch.name}}</mat-option>
                </mat-select>
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.financial_institution_branch">Company Branch cannot be empty.</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Designation</p>
                <mat-select class="each-profile-input" [(ngModel)]="advisor_data.designation_id">
                    <mat-option [value]="''">Select Designation</mat-option>
                    <mat-option *ngFor="let designation of designation_list" [value]="designation.id">{{designation.name}}</mat-option>
                </mat-select>
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.designation_id">Designation cannot be empty.</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Date of Joining *</p>
                <input
                type="text"
                class="each-profile-input"
                bsDatepicker
                [(ngModel)]="advisor_data.date_of_joining"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                />
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.date_of_joining">Date of Joining cannot be empty.</p>
            </div>
        </div>
        <div class="col-md-4">
            <div class="each-profile-input-section">
                <p class="each-profile-input-label">Product Experience</p>
                <mat-select multiple class="each-profile-input" [(ngModel)]="advisor_data.product_experience">
                    <mat-option *ngFor="let product of product_group_list" [value]="product.id">{{product.name}}</mat-option>
                </mat-select>
                <p class="each-profile-input-error" *ngIf="advisor_data_errors.product_experience">Product Experience should be atleast one.</p>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #profilePastExperienceForm>
    <table class="page-inner-table">
        <thead>
            <tr>
                <th>Actions</th>
                <th>Employment ID</th>
                <th>Company Name</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Work Years</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let experience of advisor_data.employment_details; let index = index;">
                <td>
                    <img
                    src="assets/edit-client.png"
                    class="page-table-actions"
                    (click)="openExperienceOperationModal(experience, 'Edit', index)"
                    />
                    <img
                    src="assets/delete-icon.png"
                    class="page-table-actions"
                    (click)="openDeleteExperienceModal(experience, index)"
                    />
                </td>
                <td>{{experience.prior_employment_id}}</td>
                <td>{{experience.company_name}}</td>
                <td>{{experience.start_date | date: "dd MMM YYYY"}}</td>
                <td>{{experience.end_date | date: "dd MMM YYYY"}}</td>
                <td>{{experience.work_years}} Year(s)</td>
            </tr>
            <tr>
                <td colspan="6">
                    <span class="page-table-actions" (click)="openExperienceOperationModal(experience_data, 'Add', null)">+ Add New</span>
                </td>
            </tr>
        </tbody>
    </table>
</ng-template>

<ng-template #profileServicesForm>
    <table class="page-inner-table">
        <thead>
            <tr>
                <th>Actions</th>
                <th>Name</th>
                <th>Type</th>
                <th>Cost</th>
                <th>Duration</th>
                <th>Services Offered</th>
                <th>Description</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let service of advisor_data.services">
                <td>
                    <img
                    src="assets/edit-client.png"
                    class="page-table-actions"
                    (click)="
                    openServiceOperationModal(service, 'Edit')
                    "
                    />
                    <img
                    src="assets/delete-icon.png"
                    class="page-table-actions"
                    class="page-table-actions"
                    (click)="deleteService(service)"
                    />
                </td>
                <td [matTooltip]="service.name">{{service.name}}</td>
                <td [matTooltip]="service.type">{{service.type}}</td>
                <td [matTooltip]="service.cost">${{service.cost}}</td>
                <td [matTooltip]="service.duration">{{service.duration}}</td>
                <td>
                    <ng-container *ngFor="let offer of service.services_offered_list; let index = index;">
                        <span [matTooltip]="offer.name">{{offer.name}}</span>
                        <span *ngIf="index + 1 != service.services_offered_list.length">,</span>
                    </ng-container>
                </td>
                <td [matTooltip]="service.description">{{service.description}}</td>
            </tr>
            <tr>
                <td colspan="7" >
                    <span class="page-table-actions" (click)="openServiceOperationModal(service_data, 'Add')">+ Add New</span>
                </td>
            </tr>
        </tbody>
    </table>
</ng-template>

<ng-template #experienceOperationModal>
    <div class="page-modal-section">
        <div class="page-modal-heading-section">
            <span>{{experience_data_operation_type}} Experience Details</span>
            <span class="page-modal-close-icon" (click)="closeExperienceOperationModal()">&times;</span>
        </div>
        <div class="page-modal-content-section">
            <div class="page-modal-input-section">
                <p class="page-modal-input-label">Employment ID *</p>
                <input type="text" class="page-modal-input" [(ngModel)]="experience_data.prior_employment_id" />
                <p class="page-modal-input-error" *ngIf="experience_data_errors.prior_employment_id">Employment ID is Required.</p>
            </div>
            <div class="page-modal-input-section">
                <p class="page-modal-input-label">Company Name *</p>
                <input type="text" class="page-modal-input" [(ngModel)]="experience_data.company_name" />
                <p class="page-modal-input-error" *ngIf="experience_data_errors.company_name">Company Name is Required.</p>
            </div>
            <div class="page-modal-input-section">
                <p class="page-modal-input-label">Start Date *</p>
                <input
                type="text"
                class="page-modal-input"
                bsDatepicker
                placement="left"
                [(ngModel)]="experience_data.start_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                />
                <p class="page-modal-input-error" *ngIf="experience_data_errors.start_date">Start Date is Required.</p>
            </div>
            <div class="page-modal-input-section">
                <p class="page-modal-input-label">End Date *</p>
                <input
                type="text"
                class="page-modal-input"
                bsDatepicker
                placement="left"
                [(ngModel)]="experience_data.end_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                />
                <p class="page-modal-input-error" *ngIf="experience_data_errors.end_date">End Date is Required.</p>
            </div>
            <div class="page-modal-input-section">
                <p class="page-modal-input-label">Work Years *</p>
                <input type="text" class="page-modal-input" [(ngModel)]="experience_data.work_years" (keypress)="numberOnly($event)" />
                <p class="page-modal-input-error" *ngIf="experience_data_errors.work_years">Work Years is Required.</p>
            </div>
        </div>
        <div class="page-modal-footer-section">
            <button class="page-modal-primary-button" (click)="saveExperience()">Save</button>
            <button class="page-modal-secondary-button" (click)="closeExperienceOperationModal()">Cancel</button>
        </div>
    </div>
</ng-template>

<ng-template #experienceDeleteModal>
    <div class="page-modal-section">
        <div class="page-modal-heading-section">
            <span>Delete Experience Details</span>
            <span class="page-modal-close-icon" (click)="closeDeleteExperienceModal()">&times;</span>
        </div>
        <div class="page-modal-content-section">
            <p class="page-modal-delete-description">Are you sure you want to delete?</p>
        </div>
        <div class="page-modal-footer-section">
            <button class="page-modal-primary-button" (click)="deleteExperience()">Yes</button>
            <button class="page-modal-secondary-button" (click)="closeDeleteExperienceModal()">No</button>
        </div>
    </div>
</ng-template>

<ng-template #passwordExistModal>
    <div class="page-modal-section">
        <div class="page-modal-heading-section">
            <span>Security Alert</span>
            <span class="page-modal-close-icon" (click)="closePasswordExistModal()">&times;</span>
        </div>
        <div class="page-modal-content-section">
            <p class="page-modal-delete-description">You cannot reuse your last 5 passwords. Please create a unique new password for enhanced account security.</p>
        </div>
        <div class="page-modal-footer-section">
            <button class="page-modal-primary-button" (click)="closePasswordExistModal()">OK</button>
        </div>
    </div>
</ng-template>

<ng-template #serviceOperationsModal>
    <div class="page-modal-section">
        <div class="page-modal-heading-section">
            <span>{{ services_operation_type }} Service Details</span>
            <span
            class="page-modal-close-icon"
            (click)="closeServiceOperationsModal()"
            >&times;</span
            >
        </div>
        <div class="page-modal-content-section">
            <div class="page-modal-input-section">
                <p class="page-modal-input-label">Name</p>
                <input
                type="text"
                class="page-modal-input"
                [(ngModel)]="service_data.name"
                />
                <p class="page-modal-input-error" *ngIf="service_data_errors.name">
                    Name is Required.
                </p>
            </div>
            <div class="page-modal-input-section">
                <p class="page-modal-input-label">Description</p>
                <textarea
                class="page-modal-input page-modal-textarea"
                [(ngModel)]="service_data.description"
                ></textarea>
                <p
                class="page-modal-input-error"
                *ngIf="service_data_errors.description"
                >
                Description is Required.
            </p>
        </div>

        <div class="page-modal-input-section">
            <p class="page-modal-input-label">Type</p>
            <mat-select class="page-modal-input" [(ngModel)]="service_data.type">
                <mat-option [value]="''">Select Type</mat-option>
                <mat-option [value]="'AUM'">AUM</mat-option>
                <mat-option [value]="'Monthly'">Flat Fee</mat-option>
                <mat-option [value]="'Free'">Free</mat-option>
                <mat-option [value]="'Hourly'">Hourly</mat-option>
                <mat-option [value]="'Subscription'">Subscription</mat-option>
            </mat-select>
            <p class="page-modal-input-error" *ngIf="service_data_errors.type">
                Type is Required.
            </p>
        </div>

        <div class="page-modal-input-section">
            <p class="page-modal-input-label">Cost($)</p>
            <input
            type="text"
            class="page-modal-input"
            [(ngModel)]="service_data.cost"
            (keypress)="numberOnly($event)"
            />
            <p class="page-modal-input-error" *ngIf="service_data_errors.cost">
                Cost is Required.
            </p>
        </div>

        <div class="page-modal-input-section">
            <p class="page-modal-input-label">Duration</p>
            <mat-select class="page-modal-input" [(ngModel)]="service_data.duration">
                <mat-option [value]="''">Select Duration</mat-option>
                <mat-option [value]="'Hourly'">Hourly</mat-option>
                <mat-option [value]="'Monthly'">Monthly</mat-option>
                <mat-option [value]="'Quarterly'">Quarterly</mat-option>
                <mat-option [value]="'Half Yearly'">Half Yearly</mat-option>
                <mat-option [value]="'Yearly'">Yearly</mat-option>
                <mat-option [value]="'NA'">NA</mat-option>
            </mat-select>
            <p class="page-modal-input-error" *ngIf="service_data_errors.duration">
                Duration is Required.
            </p>
        </div>

        <div class="page-modal-input-section">
            <p class="page-modal-input-label">Service Offered</p>
            <mat-select multiple class="page-modal-input" [(ngModel)]="service_data.services_offered">
                <mat-option *ngFor="let service of services_offered_list" [value]="service.id">{{service.name}}</mat-option>
            </mat-select>
            <p class="page-modal-input-error" *ngIf="service_data_errors.services_offered">
                Service Offered is Required.
            </p>
        </div>


    </div>
    <div class="page-modal-footer-section">
        <button class="page-modal-primary-button" (click)="saveServiceData()">
            Save
        </button>
        <button
        class="page-modal-secondary-button"
        (click)="closeServiceOperationsModal()"
        >
        Cancel
    </button>
</div>
</div>
</ng-template>

<ng-template #serviceDeleteModal>
    <div class="page-modal-section">
        <div class="page-modal-heading-section">
            <span>Delete Service Details</span>
            <span class="page-modal-close-icon" (click)="closeDeleteServiceModal()">&times;</span>
        </div>
        <div class="page-modal-content-section">
            <p class="page-modal-delete-description">Are you sure you want to delete?</p>
        </div>
        <div class="page-modal-footer-section">
            <button class="page-modal-primary-button" (click)="deleteServiceDetails()">Yes</button>
            <button class="page-modal-secondary-button" (click)="closeDeleteServiceModal()">No</button>
        </div>
    </div>
</ng-template>

<ng-template #connectCalenderIntegrationModal>
    <div class="page-modal-section">
        <div class="page-modal-heading-section">
            <span>Connect to {{calender_integration_type}}</span>
            <span class="page-modal-close-icon" (click)="closeconnectCalenderIntegration()">&times;</span>
        </div>
        <div class="page-modal-content-section">
            <div class="page-modal-input-section">
                <p class="page-modal-input-label">URL</p>
                <input type="text" class="page-modal-input" [(ngModel)]="calender_integration_link" />
                <p class="page-modal-input-error" *ngIf="calender_integration_link_error">URL should be valid.</p>
            </div>
            <div class="page-modal-input-section">
              <p class="page-modal-input-label">API Key</p>
              <input type="text" class="page-modal-input" [(ngModel)]="calender_api_key" />
              <p class="page-modal-input-error" *ngIf="calender_api_key_error">API Key should be valid.</p>
          </div>
        </div>
        <div class="page-modal-footer-section">
            <button class="page-modal-primary-button" (click)="connectCalenderIntegration()">Connect</button>
            <button class="page-modal-secondary-button" (click)="closeconnectCalenderIntegration()">Cancel</button>
        </div>
    </div>
</ng-template>
